const IntercomSpacer = () => <div style={{ paddingBottom: 50 }} />

export default IntercomSpacer
